// rules.jsx
import React, { useEffect, useState } from 'react';
import './thankyou.css';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { selectAdminToken } from "../../admin/sessionSlice";
import { fetchReport } from '../../functions/fetchReport';
import { setBackButtonUrl } from '../uiSlice';


function ThankYou(){
  const dispatch=useDispatch();
  const { user } = useSelector((state) => state.auth);
  const adminToken = useSelector(selectAdminToken);
  const { data: themeData } = useSelector((state) => state.theme);
  const [time,setTime] =useState(0);


      useEffect(() => {
        dispatch(setBackButtonUrl(user.backButtonRedirect));
      }, [user]);
  
  console.log(user,themeData);
   // Fetch questions
    useEffect(() => {
      console.log("check---",user,themeData)
      if (!user || !themeData) return;
      fetchReport({
        userId: user.userId,
        token: adminToken,
      })
        .then((data) => {
          let processTimeData=data.report.time.substring(3);
          setTime(processTimeData);
          console.log(data);
        })
        .catch(console.error);
    }, [user, adminToken,themeData]);
  return (
    <>
      <div className="thank-you-container">
        <div className='thank-you-text'>The spaceship is fully restored and ready for takeoff. Your crew completed the mission in {time} minutes. The journey continues! 🚀</div>
      </div>
    </>
  );
}

export default ThankYou;
